
import { COLLECT_INIT_WIDTH, COLLECT_EXPEND_WIDTH } from "./const.js"
import slotWidget from "./slot-widget"
import redemptionDrawer from "./redemption-drawer"

export default {
  components: {
    slotWidget,
    redemptionDrawer
  },
  props: {
    // pattern: {
    //   type: String,
    //   default: 'repeat'
    // },
    coreData: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      drawerSize: COLLECT_INIT_WIDTH
    }
  },
  computed: {},
  watch: {},
  methods: {
    handleOpen() {
      this.$refs.redemptionDrawer.open()
    }
  }
}
